<template>
<div>
    <!-- Header -->
    <base-header class="pb-6 pb-4 pt-5 pt-md-6 text-center">
    </base-header>
    <br />
    <!-- Card stats -->
    <b-container fluid class="">
        <b-row class="justify-content-center">
            <b-col lg="12">
                <card header-classes="bg-transparent">
                    <b-row>
                        <!-- Start -->
                        <b-container fluid>
                            <b-row class="mb-4">
                                <b-col cols="12">
                                    <h4 class="text-primary">DASHBOARD</h4>
                                </b-col>
                            </b-row>

                            <b-row class="justify-content-center">
                                <!-- DALAM PROSES -->
                                <b-col xl="4" md="5" class="mb-4">
                                    <stats-card2 title="DALAM PROSES" type="gradient-warning" :sub-title="DashboardPeraku.dalam_proses.toString()" icon="fa fa-hourglass-half fa-3x text-white bg-warning p-3 rounded-circle shadow" class="border border-warning rounded-xl p-4 shadow-lg" variant="warning">
                                        <template slot="footer">
                                            <base-button outline type="warning" class="w-100 fw-bold" @click="divcomDalamProses()">
                                                Lihat Senarai
                                            </base-button>
                                        </template>
                                    </stats-card2>
                                </b-col>

                                <!-- DALAM TINDAKAN -->
                                <b-col xl="4" md="5" class="mb-4">
                                    <stats-card2 title="DALAM TINDAKAN" type="gradient-primary" :sub-title="DashboardPeraku.dalam_tindakan.toString()" icon="fa fa-tasks fa-3x text-white bg-primary p-3 rounded-circle shadow" class="border border-primary rounded-xl p-4 shadow-lg" variant="primary">
                                        <template slot="footer">
                                            <base-button outline type="primary" class="w-100 fw-bold" @click="divcomDalamTindakan()">
                                                Lihat Senarai
                                            </base-button>
                                        </template>
                                    </stats-card2>
                                </b-col>

                                <!-- SELESAI -->
                                <b-col xl="4" md="5" class="mb-4">
                                    <stats-card2 title="SELESAI" type="gradient-success" :sub-title="DashboardPeraku.selesai.toString()" icon="fa fa-check-circle fa-3x text-white bg-success p-3 rounded-circle shadow" class="border border-success rounded-xl p-4 shadow-lg" variant="success">
                                        <template slot="footer">
                                            <base-button outline type="success" class="w-100 fw-bold" @click="divcomSelesai()">
                                                Lihat Senarai
                                            </base-button>
                                        </template>
                                    </stats-card2>
                                </b-col>

                            </b-row>

                        </b-container>
                        <!-- End -->
                    </b-row>
                    <b-row>
                        <b-col>&nbsp;&nbsp;&nbsp;&nbsp;</b-col>
                    </b-row>
                    <b-row>
                        <b-col>&nbsp;&nbsp;&nbsp;&nbsp;</b-col>
                    </b-row>
                </card>
            </b-col>

            <br /><br /><br />
            <b-col lg="12">
                <card header-classes="bg-transparent">
                    <b-container fluid>
                        <div v-if="comdalamTindakan">
                            <SenaraiPentadbirBGE :kiraan="2"  />
                        </div>
                        <div v-if="comSelesai">
                            <SenaraiPentadbirBGE :kiraan="3"  />
                        </div>
                        <div v-if="comdalamProses">
                            <SenaraiPentadbirBGE :kiraan="1"  />
                        </div>
                    </b-container>
                </card>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import SenaraiPentadbirBGE from "@/views/Skg/Pentadbir_BGE/Senarai.vue";
import senaraiSelesai from "@/views/Skg/senaraiSelesai.vue";
import senaraiPADlmTindakan from "@/views/Skg/senaraiPADlmTindakan.vue";
import GetsalaryService from "@/services/salaryService.js";
import StatsCard2 from "@/components/Cards/StatsCard2.vue";
export default {
    components: {
SenaraiPentadbirBGE,
        senaraiSelesai,
        senaraiPADlmTindakan,
        StatsCard2,
    },
    data() {
        return {
            DashboardPeraku: {
                
                dalam_proses: 3,
                dalam_tindakan: 1,
                selesai: 5,
            },
            comdalamTindakan: false,
            comSelesai: false,
            comdalamProses: false,
            Items: [],};
    },

    methods: {
        divcomDalamTindakan() {
            this.comdalamTindakan = true;
            this.comSelesai = false;
            this.comdalamProses = false;
        },
        divcomDalamProses() {
            this.comdalamTindakan = false;
            this.comSelesai = false;
            this.comdalamProses = true;
        },
        divcomSelesai() {
            this.comdalamTindakan = false;
            this.comSelesai = true;
        },
    },

    created() {

    },

    computed: {

    },
};
</script>

<style scoped>
/* Optional: Customize styles for better aesthetics */
h4 {
    font-weight: 600;
    text-transform: uppercase;
}

.stats-card2 {
    transition: transform 0.3s;
}

.stats-card2:hover {
    transform: scale(1.05);
    /* Scale up on hover */
}

.base-button {
    transition: background-color 0.3s;
}

.base-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Slight change on hover */
}
</style>
